export default __webpack_public_path__ + "static/3cc0d38b3e8d93132c90fec5d3d06c68.svg";